module.exports = __webpack_public_path__ + "static/horizons01-bb75b381cde6d9f3350c48728be1e0c5.png";